export default [
    {
        path: 'paciente-observacao',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-paciente-observacao' */
            '@/views/pronto-atendimento/paciente-observacao/Index'
        ),
        redirect: 'paciente-observacao/index',
        children: [
            {
                name: 'pronto-atendimento-paciente-observacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-paciente-observacao' */
                    '@/views/pronto-atendimento/paciente-observacao/List.vue'),
            },
            {
                name: 'pronto-atendimento-paciente-observacao-create',
                path: 'create/:id/:plantaoId',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-paciente-observacao' */
                    '@/views/pronto-atendimento/paciente-observacao/Form'
                ),
            },
        ]
    }
]